import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { TextBox } from "../../core/components/textBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { DropDownList } from "../../core/components/dropDownList";
import EditTranslations from "../editTranslations";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react"
export default class EditAdrTypes extends React.Component<EditAdrTypesProps, EditAdrTypesState> {
    private _factory = ComponentHelper.createFactory();
    private _editTranslationsRef: EditTranslations = null;
    private _gridOptions: any;
    private _translations: string[] = null;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._saveAdrTyp();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this._closeDialog();
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = { gridData: [], dialogOpen: false, selectedItem: null };
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={true}>
                    {this._createTextbox()}
                    {this._createTranslationLabel()}
                    {this._createDropDownList()}                    
                </Dialog>
                <EditTranslations
                    ref={(r) => this._editTranslationsRef = r}
                    label={Config.translations.editLabel}
                    saveGerman={(value: string) => {
                        let item = this.state.selectedItem;
                        item.GermanName = value;
                        this.setState({ selectedItem: item });
                    }}
                />
            </div>
        );
    }

    private _getSelectedItemSavely = (): AdrTyp => {
        if (Helper.hasValue(this.state.selectedItem)) {
            return this.state.selectedItem;
        }

        return {
            GermanName: "",
            IsNew: true,
            IsRowId: null,
            Name: "",
            Option: {
                Id: 0,
                Description: ""
            },
            OptionLabel: "",
            Id: 0
        }
    }

    private _createTextbox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        console.log(this.state.selectedItem)
        props.value = this.state.selectedItem.Name;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let selectedItem = this.state.selectedItem;
            selectedItem.Name = value;
            this.setState({ selectedItem: selectedItem });
        }

        return (
            <FieldInstance label={this._translations["Standard.Name"]} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _createTranslationLabel = () => {
        if (!this.state.selectedItem.IsNew) {
            const labelStyle: React.CSSProperties = {
                cursor: "pointer",
                textDecoration: "Underline"
            }
            const divStyle: React.CSSProperties = {
                display: "flex",
                justifyContent: "flex-end",
                fontSize: "10px",
                marginTop: "2px"
            }
            return (
                <FieldInstance noLabel={true}>
                    <div style={divStyle}>
                        <label
                            style={labelStyle}
                            onClick={this._openTranslationsDialog}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}
                        </label>
                    </div>
                </FieldInstance>);
        } else {
            return <></>;
        }
    }

    private _openTranslationsDialog = () => {
        this._editTranslationsRef.openDialog(this.state.selectedItem.IsRowId, 5, "value_0", this.state.selectedItem.GermanName);
    }

    private _createDropDownList = () => {
        let props = this._factory.getDefaultDropDownProps();
        props.field.dataSourceUrl = "AddressSettings/GetOptions";
        props.field.dataTextField = "Description";
        props.field.dataValueField = "Id";
        props.value = Helper.hasValue(this.state.selectedItem.Option) ? this.state.selectedItem.Option.Id : null;
        props.onChange = (field: { model: string }, value: any, dataItem?: Option) => {
            let selectedItem = this.state.selectedItem;
            selectedItem.Option = dataItem;
            selectedItem.OptionLabel = dataItem.Description;
            this.setState({ selectedItem: selectedItem });
        }
        props.onDataLoaded = (field: { model: string }, data: any) => { };
        return (
            <FieldInstance label={this._translations["WebSMS.GeneralSettings.Address.Option"]} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private _saveAdrTyp = () => {
        let url = "AddressSettings/SaveAdrType";
        HTTPService.post<JsonResultClass>(url, { model: this.state.selectedItem }).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _getGridData = () => {
        let url = "AddressSettings/GetAdrTypes";
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {                   
                    this.setState({ gridData: result.Data });                    
                }
            });
    }

    private validate = async (adrTyp) => {
        let isOK = await DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]);
        if (!isOK)
            return false;

        const httpResult = await HTTPService.get<JsonResultClass<boolean>>(`AddressSettings/IsInUse?adrTyp=${adrTyp}`);
        const isInUse = httpResult.Code == 0 && httpResult.Data;
        if (isInUse) {
            return await DialogHelper.confirm(Helper.getTranslation("WebSMS.GeneralSettings.Address.AdrTyp.InUse"));
        } else {
            return true;
        }
    }

    private _deleteAdrTyp = () => {
        this.validate(this.state.selectedItem.Id).then(isOk => {
            if (isOk) {
                let url = "AddressSettings/DeleteAdrType";
                HTTPService.post<JsonResultClass>(url, { model: this.state.selectedItem }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = (dataItem: AdrTyp = null) => {
        let selectedItem: AdrTyp;
        if (Helper.hasValue(dataItem)) {
            selectedItem = dataItem;
        } else {            
            selectedItem = {
                GermanName: "",
                IsNew: true,
                IsRowId: null,
                Name: "",
                Option: {
                    Id: 0,
                    Description: ""
                },
                OptionLabel:"",
                Id: 0
            }
        }
        this.setState({ dialogOpen: true, selectedItem: selectedItem });
    }

    private _closeDialog = () => {
        this.setState({ dialogOpen: false });
    }

    private _createGrid = () => {

        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this._gridOptions) && Helper.hasValue(this._translations);

        if (fullLoaded) {

            const onSelect = Helper.hasValue(this.state.selectedItem);

            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: onSelect });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: onSelect });
            let grid = (
                <Grid data={this.state.gridData} options={this._gridOptions} id="adrTypesGrid" onSelectionChanged={this._onSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} selectFilter={this.state.selectedItem == null ? null : this.state.selectedItem.Name} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: AdrTyp) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this._openDialog(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this._openDialog();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._deleteAdrTyp();
        }
    }

    private _onSelectedChange = (dataItem: AdrTyp) => {
        if (Helper.hasValue(dataItem))
            this.setState({ selectedItem: dataItem });
    }

    componentDidMount() {
        this._gridOptions = this.props.context.adrTypesGridOptions;
        this._translations = this.props.context.translations;
        this._getGridData();
    }

    render() {

        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

interface EditAdrTypesProps {
    context: ContextGeneralSettingsApp;
}

interface EditAdrTypesState {
    dialogOpen: boolean;
    selectedItem: AdrTyp;
    gridData: AdrTyp[];
}

interface AdrTyp {
    Id: number;
    Name: string;
    GermanName: string;
    Option: Option;
    OptionLabel: string;
    IsRowId: number;
    IsNew: boolean;
}

interface Option {
    Id: number;
    Description: string;
}